import { render, staticRenderFns } from "./AcceptInvitationPage.vue?vue&type=template&id=eed18baa&scoped=true"
import script from "./AcceptInvitationPage.vue?vue&type=script&lang=js"
export * from "./AcceptInvitationPage.vue?vue&type=script&lang=js"
import style0 from "./AcceptInvitationPage.vue?vue&type=style&index=0&id=eed18baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed18baa",
  null
  
)

export default component.exports